export const siteSettings = {
  name: "Ace Central Market",
  link: "https://acecentralmarket.net",
  email: "support@acecentralmarket.net",
  appLink: "https://app.acecentralmarket.net",
};
